export default () => ({
  titulareslista: [],
  titularesinfo: null,
  dashboard: null,
  leyendasLista:null,
  totalUsuarios: 0,
  currentPage: 1,
  perPage: 20,
});
